import { LoomSiteAri } from '@atlassian/ari';

import { createRelayResource } from '@townsquare/relay-utils';
import { getAggRelayEnvironment } from '@townsquare/relay-utils/agg-environment';
import type { ResourceContext } from '@townsquare/router/types';

import LoomFeedListQuery, {
	LoomFeedListQuery as LoomFeedListQueryType,
} from '../components/feed/__generated__/LoomFeedListQuery.graphql';

export const loomFeedResource = createRelayResource<LoomFeedListQueryType>({
	getQuery: (_, resourceStoreContext) => {
		const context = resourceStoreContext as ResourceContext;
		const cloudId = context.collabContext?.rovoWorkspace;

		return {
			query: LoomFeedListQuery,
			variables: {
				loomSiteAri: cloudId ? LoomSiteAri.create({ siteId: cloudId }).toString() : '',
				isEnabled: !!cloudId,
			},
			environment: getAggRelayEnvironment(),
		};
	},
	maxAge: 60_000 * 30, // 30 minute cache during the SPA session to avoid flickering
});
